import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Switch,
  TextField,
  IconButton,
  Button,
  Paper,
  TableContainer,
  makeStyles,
  Typography,
  CircularProgress,
  Grid,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import StyledButton from "../../../common/models/Button";
import { appUrl } from "../../../../utils/config";
import axios from "axios";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: theme.spacing(2),
  },
  table: {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    width: "650px",
  },
  headerCell: {
    fontWeight: 600,
    color: "#333",
    backgroundColor: "#f0f0f0",
    padding: "10px 16px",
    textAlign: "left",
  },
  bodyCell: {
    padding: "10px 16px",
    textAlign: "left",
    verticalAlign: "middle",
  },
  textField: {
    "& input": {
      padding: "6px 8px",
      height: "30px",
    },
  },
  addButton: {
    marginTop: theme.spacing(2),
    backgroundColor: "#fff",
    color: "#000",
    borderRadius: "20px",
    padding: "6px 16px",
    textTransform: "none",
    fontWeight: 600,
    border: "1px solid #000",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  addIconCircle: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "2px solid #000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    fontSize: "16px",
    fontWeight: 600,
  },
  deleteIcon: {
    color: theme.palette.error.main,
  },
  switchBase: {
    "&.Mui-checked": {
      color: "#007bff",
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#007bff",
    },
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "8px",
    gap: "4px",
  },
  iconBtn: {
    padding: "1px",
  },
  noteText: {
    marginTop: theme.spacing(2),
    fontSize: "14px",
    color: "#333",
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginTop: theme.spacing(4),
  },
  saveButton: {
    backgroundColor: "#EC6535",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#993d13",
    },
  },
  backButton: {
    backgroundColor: "#707070",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#4d4d4d",
    },
  },
}));

const POStatusTab = (props) => {
  const { addSponsorList, rowData, rowNetwork, updateNetworkData } = props;
  const classes = useStyles();

  const [poStatuses, setPoStatuses] = useState([]); // State to store PO statuses
  const [loading, setLoading] = useState(false); // State to manage loading spinner
  const [error, setError] = useState("");
  const [isUpdated, setIsUpdated] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [savingStates, setSavingStates] = useState({});
  const [isSaving, setIsSaving] = useState(false); // Track save & next button loading

  const network = addSponsorList?.data?.network || rowNetwork;
  const networkUrl = updateNetworkData?.ecosystemUrl || rowData?.networkURL;

  const fetchPoStatuses = async () => {
    setLoading(true); // Show loading spinner
    setError(""); // Reset error state
    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchFGStatuses/false`; // API endpoint
      const response = await axios.get(url);

      if (response.data?.status === true || response.data?.status === "true") {
        // Map the API response to match the expected structure
        const mappedStatuses = response.data?.data?.poStatuses?.map(
          (status) => ({
            id: status.status_id,
            name: status.status_name,
            selected: status.activated,
            type: status.status_type,
            isNew: false,
            newStatusName: status.newStatusName,
          })
        );

        setPoStatuses(mappedStatuses || []); // Update state with mapped statuses
      } else {
        console.error("Failed to fetch PO statuses:", response.data?.message);
        setError(response.data?.message || "Failed to fetch PO statuses.");
      }
    } catch (error) {
      console.error("Error fetching PO statuses:", error);
      setError("An error occurred while fetching PO statuses.");
    } finally {
      setLoading(false); // Hide loading spinner
    }
  };
console.log("PoStatus",poStatuses)
  useEffect(() => {
    if (networkUrl && network) {
      fetchPoStatuses();
    }
  }, [networkUrl, network]);

  const saveNewPo = async (index) => {
    if (savingStates[index]) return;
    setSavingStates((prev) => ({ ...prev, [index]: true }));
    try {
      const newStatus = poStatuses[index]; // Get the new status to save
      if (!newStatus.name.trim()) {
        setError("Please provide a name for the new PO status.");
        setSavingStates((prev) => ({ ...prev, [index]: false }));
        return;
      }

      const payload = {
        ecosystemId: addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
        sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
        saslBatchStatusesList: [
          {
            //status_id: newStatus.id, // Use the ID from the new status
            status_name: newStatus.name, // Use the name from the new status
            // Use the type from the new status
            status_type: "New",
            object_type: "PO",
            markForDelete: false,
            activated: newStatus.selected,
          },
        ],
      };


      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/addSASLBatchStatuses`; // API endpoint
      const response = await axios.post(url, payload);
      if (response.data?.status === true || response.data?.status === "true") {
        fetchPoStatuses();
        props.setPoStatus((prev) => !prev);

        // Update the state to mark the status as saved
        setPoStatuses((prev) =>
          prev.map((status, i) =>
            i === index
              ? { ...status, id: response.data?.data?.id, isNew: false }
              : status
          )
        );
      } else {
        console.error("Failed to save new PO status:", response.data?.message);
        setError(response.data?.message || "Failed to save new PO status.");
      }
    } catch (error) {
      console.error("Error saving new PO status:", error);
      setError("An error occurred while saving the new PO status.");
    }
    setSavingStates((prev) => ({ ...prev, [index]: false }));
  };

  const handleDelete = async (index) => {
    // Prevent deleting 'Created' and 'New PO' only
    // if (poStatuses[index].name === "Created" || poStatuses[index].name === "New PO") {
    //   return;
    // }
    try {
      const statusToDelete = poStatuses[index]; // Get the status to delete
      if (statusToDelete.isNew) {
        setPoStatuses((prev) => prev.filter((_, i) => i !== index));
        return;
      }

      // Prepare the payload for the API
      const payload = {
        ecosystemId: addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
        sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
        poStatuses: [
          {
            status_id: statusToDelete.id, // ID of the status
            status_name: statusToDelete.name, // Name of the status
            activated: statusToDelete.selected, // Current activation state
            markForDelete: true, // Mark the status for deletion
            object_type: "PO",
            newStatusName: statusToDelete.newStatusName, // No new name for deletion
            status_type: statusToDelete.type,
          },
        ],
        batchStatuses: [],
        shipmentStatuses: [],
      };


      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/updateFGStatuses`; // API endpoint
      const response = await axios.post(url, payload);
      if (response.data?.status === true || response.data?.status === "true") {
        fetchPoStatuses();
        props.setPoStatus((prev) => !prev);

        // Update the state to remove the deleted status
        setPoStatuses((prev) => prev.filter((_, i) => i !== index));
      } else {
        console.error("Failed to delete PO status:", response.data?.message);
        setError(response.data?.message || "Failed to delete PO status.");
      }
    } catch (error) {
      console.error("Error deleting PO status:", error);
      setError("An error occurred while deleting the PO status.");
    }
  };

  const handleNextClick = async () => {
    try {
      // Validate that at least one PO status is selected

      const isAnyStatusSelected = poStatuses.filter(
        (status) => status.isUpdated
      );
      if (!isAnyStatusSelected.length) {
        props.handleNext(); // Directly move to the next tab
        return;
      }
      // if (!isAnyStatusSelected.length) {
      //   setErrorMessage("Please activate at least one PO status.");
      //   return;
      // }
      if (poStatuses.every((status) => !status.selected)) {
        setErrorMessage("Please enable at least one in toggle mode.");
        return;
      }

      setIsSaving(true); // Start loading

      // Prepare the payload for the API
      const payload = {
        ecosystemId: addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
        sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
        poStatuses: isAnyStatusSelected.map((status) => ({
          status_id: status.id, // ID of the PO status
          status_name: status.name, // Name of the PO status
          activated: status.selected, // Activation state
          object_type: "PO",
          // markForDelete: status.markForDelete || false, // Mark for deletion if applicable
          newStatusName: status.newName, // New name if updated
          status_type: status.type,
          markForDelete: false,
        })),
        batchStatuses: [],
        shipmentStatuses: [],
      };


      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/updateFGStatuses`; // API endpoint
      const response = await axios.post(url, payload);
      fetchPoStatuses();
      if (response.data?.status === true || response.data?.status === "true") {

        // Move to the next tab
        props.handleNext();
      } else {
        console.error("Failed to update PO statuses:", response.data?.message);
        setError(response.data?.message || "Failed to update PO statuses.");
      }
    } catch (error) {
      console.error("Error updating PO statuses:", error);
      setError("An error occurred while updating PO statuses.");
    } finally {
      setIsSaving(false); // Stop loading
    }
  };

  // const handleToggle = (index) => {
  //   const updated = [...poStatuses];
  //   updated[index].selected = !updated[index].selected;
  //   updated[index].isUpdated = true;
  //   setPoStatuses(updated);
  //   setIsUpdated(true);
  // };
  const handleToggle = (index) => {
    const updated = [...poStatuses];
    const toggledStatus = updated[index];

    // Prevent toggling for 'Created' and 'New PO' only
    if (toggledStatus.name === "Created" || toggledStatus.name === "New PO") {
      return;
    }
    toggledStatus.selected = !toggledStatus.selected;
    toggledStatus.isUpdated = true;
    setPoStatuses(updated);
    setIsUpdated(true);
  };

  const handleNameChange = (index, value) => {
    const updated = [...poStatuses];
    // Prevent editing name for 'Created' and 'New PO' only
    // if (updated[index].name === "Created" || updated[index].name === "New PO") {
    //   return;
    // }
    updated[index].name = value;
    setPoStatuses(updated);
    setIsUpdated(true);
  };

  // const handleDelete = (index) => {
  //   const updated = poStatuses.filter((_, i) => i !== index);
  //   setPoStatuses(updated);
  // };

  const handleAddStatus = () => {
    //const nextId = (poStatuses.length + 1).toString().padStart(2, "0");
    setPoStatuses([
      ...poStatuses,
      {
        // id: nextId,
        name: "",
        selected: false,
        isNew: true,
        isDelete:true,
      },
    ]);
  };
  // const saveNewPo = () => {
  //   console.log("Save new UOM action triggered");
  //   // Add logic to save the new UOM
  // };

  // Define handleCancel function
  // const handleCancel = () => {
  //   console.log("Cancel action triggered");
  //   // Add logic to handle cancel action
  // };
  const handleCancel = (index) => {
    setPoStatuses((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <div className={classes.container}>
      <TableContainer component={Paper} className={classes.table}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.headerCell}>Selection</TableCell>
              <TableCell className={classes.headerCell}>PO Status</TableCell>
              <TableCell className={classes.headerCell}>PO Status ID</TableCell>
              <TableCell className={classes.headerCell}>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>

            {/* {loading ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100px",
                    }}
                  >
                    <CircularProgress />
                  </div>
                </TableCell>
              </TableRow>
            ) : error ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "60px",
                      backgroundColor: "#ffecec",
                      color: "#b00020",
                      border: "1px solid #ff9999",
                    }}
                  >
                    <Typography>{error}</Typography>
                  </div>
                </TableCell>
              </TableRow>
            ) : poStatuses.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "60px",
                      color: "#666",
                    }}
                  >
                    <Typography>No PO Statuses Found</Typography>
                  </div>
                </TableCell>
              </TableRow>
            ) : (
              poStatuses.map((status, index) => (

                <TableRow key={status.id || index}>
                  <TableCell className={classes.bodyCell}>
                    <Switch
                      checked={status.selected}
                      onChange={() => handleToggle(index)}
                      // disabled={disabled}
                      classes={{
                        switchBase: classes.switchBase,
                      }}
                    />
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {status.isNew ? (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <TextField
                          className={classes.textField}
                          placeholder="Type Text Here"
                          value={status.name}
                          onChange={(e) =>
                            handleNameChange(index, e.target.value)
                          }
                          variant="outlined"
                          inputProps={{
                            onBeforeInput: (e) => {
                              const allowedChars = /^[a-zA-Z0-9\s\-()]+$/;
                              if (!allowedChars.test(e.data)) {
                                e.preventDefault();
                              }
                            }
                          }}
                        />
                        <div className={classes.inlineActions}>
                          <IconButton
                            onClick={() => handleCancel(index)}
                            className={classes.iconBtn}
                          >
                            <CancelIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                              onClick={() => saveNewPo(index)}
                              className={classes.iconBtn}
                              disabled={
                                !status.name?.trim() ||
                                poStatuses.some(
                                  (s, i) =>
                                    i !== index &&
                                    s.name?.trim().toLowerCase() === status.name?.trim().toLowerCase()
                                ) || savingStates[index]
                              }
                          >
                            <SaveIcon fontSize="small" />
                          </IconButton>
                        </div>
                      </div>
                    ) : (
                      status.name
                    )}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {status.id}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {(status.isNew === true ||
                      (status.type && status.type !== "Default")) && (
                        <IconButton
                          size="small"
                          onClick={() => handleDelete(index)}
                          className={classes.deleteIcon}
                        >
                          <DeleteIcon />
                        </IconButton>
                      )}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
          {/* <TableBody> */}

            {loading ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100px",
                    }}
                  >
                    <CircularProgress />
                  </div>
                </TableCell>
              </TableRow>
            ) : error ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "60px",
                      backgroundColor: "#ffecec",
                      color: "#b00020",
                      border: "1px solid #ff9999",
                    }}
                  >
                    <Typography>{error}</Typography>
                  </div>
                </TableCell>
              </TableRow>
            ) : poStatuses.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "60px",
                      color: "#666",
                    }}
                  >
                    <Typography>No PO Statuses Found</Typography>
                  </div>
                </TableCell>
              </TableRow>
            ) : (
              poStatuses.map((status, index) => {
                // Only 'Created' and 'New PO' are always on and not editable
                const isSpecialStatus = status.name === "Created" || status.name === "New PO";
                let disabled = false;
                let checked = status.selected;
                if (isSpecialStatus) {
                  disabled = true;
                  checked = true;
                }
                return (
                  <TableRow key={status.id || index}>
                    <TableCell className={classes.bodyCell}>
                      <Switch
                        checked={checked}
                        onChange={() => handleToggle(index)}
                        disabled={disabled}
                        classes={{
                          switchBase: classes.switchBase,
                        }}
                      />
                    </TableCell>
                    {/* <TableCell className={classes.bodyCell}>
                      {status.isNew ? (
                        isSpecialStatus ? (
                          status.name
                        ) : (
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <TextField
                              className={classes.textField}
                              placeholder="Type Text Here"
                              value={status.name}
                              onChange={(e) => handleNameChange(index, e.target.value)}
                              onBlur={(e) => {
                                const trimmed = e.target.value.trim();
                                if (trimmed !== e.target.value) {
                                  handleNameChange(index, trimmed);
                                }
                              }}
                              variant="outlined"
                                                          inputProps={{
                              onBeforeInput: (e) => {
                                const allowedChars = /^[a-zA-Z0-9\s\-()]+$/;
                                if (!allowedChars.test(e.data)) {
                                  e.preventDefault();
                                }
                              }
                            }}
                            />
                            <div className={classes.inlineActions}>
                              <IconButton
                                onClick={() => handleCancel(index)}
                                className={classes.iconBtn}
                              >
                                <CancelIcon fontSize="small" />
                              </IconButton>
                              <IconButton
                                onClick={() => saveNewPo(index)}
                                className={classes.iconBtn}
                                                              disabled={
                                !status.name?.trim() ||
                                poStatuses.some(
                                  (s, i) =>
                                    i !== index &&
                                    s.name?.trim().toLowerCase() === status.name?.trim().toLowerCase()
                                ) || savingStates[index]
                              }
                              >
                                <SaveIcon fontSize="small" />
                              </IconButton>
                            </div>
                          </div>
                        )
                      ) : (
                        status.name
                      )}
                    </TableCell> */}
                    <TableCell className={classes.bodyCell}>
                      {status.isNew ? (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <TextField
                            className={classes.textField}
                            placeholder="Type Text Here"
                            value={status.name}
                            onChange={(e) =>
                              handleNameChange(index, e.target.value)
                            }
                            onBlur={(e) => {
                              const trimmed = e.target.value.trim();
                              if (trimmed !== e.target.value) {
                                handleNameChange(index, trimmed);
                              }
                            }}
                            variant="outlined"
                            inputProps={{
                              onBeforeInput: (e) => {
                                const allowedChars = /^[a-zA-Z0-9\s\-()]+$/;
                                if (!allowedChars.test(e.data)) {
                                  e.preventDefault();
                                }
                              }
                            }}
                          />
                          <div className={classes.inlineActions}>
                            <IconButton
                              onClick={() => handleCancel(index)}
                              className={classes.iconBtn}
                            >
                              <CancelIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                              onClick={() => saveNewPo(index)}
                              className={classes.iconBtn}
                              disabled={
                                !status.name?.trim() ||
                                poStatuses.some(
                                  (s, i) =>
                                    i !== index &&
                                    s.name?.trim().toLowerCase() === status.name?.trim().toLowerCase()
                                ) || savingStates[index]
                              }
                            >
                              <SaveIcon fontSize="small" />
                            </IconButton>
                          </div>
                        </div>
                      ) : (
                        status.name
                      )}
                    </TableCell>
                    <TableCell className={classes.bodyCell}>
                      {status.id}
                    </TableCell>
                    {/* <TableCell className={classes.bodyCell}>
                      {isSpecialStatus ? null : ((status.isNew === true ||
                        (status.type && status.type !== "Default")) && (
                          <IconButton
                            size="small"
                            onClick={() => handleDelete(index)}
                            className={classes.deleteIcon}
                          >
                            <DeleteIcon />
                          </IconButton>
                        ))}
                    </TableCell> */}
                    <TableCell className={classes.bodyCell}>
                      {(status.isNew === true ||
                        (status.type === "New" && status.lastUpdatedBy !== "support@schrocken.com")) &&
                        (
                        <IconButton
                          size="small"
                          onClick={() => handleDelete(index)}
                          className={classes.deleteIcon}
                        >
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {errorMessage && (
        <div style={{ color: "red", marginTop: 10 }} className="error-message">
          {errorMessage}
        </div>
      )}
      {/* <Typography className={classes.noteText}>
        Note - If New PO Status is selected, Created and Shared with CMO
        statuses cannot be selected and vice versa.
      </Typography> */}

      <Button
        variant="outlined"
        onClick={handleAddStatus}
        className={classes.addButton}
      >
        <span className={classes.addIconCircle}>+</span>
        Add New PO Status
      </Button>

      <div className={classes.footer}>
        <Grid
          className={classes.backButton}
          onClick={() => {
            props.handleBack();
          }}
        >
          <ChevronLeftIcon />
          Back
        </Grid>
        <Grid
          className={classes.saveButton}
          onClick={() => {
            if (isUpdated) {
              handleNextClick(); // Call API and move to the next tab if updates are made
            } else {
              props.handleNext(); // Directly move to the next tab if no updates are made
            }
          }}
          style={{
            opacity: isSaving ? 0.7 : 1,
            pointerEvents: isSaving ? 'none' : 'auto' 
          }}
          // onClick={() => {
          //   handleNextClick(); // Call API and move to the next tab if updates are made
          // }}
        >
          {isSaving ? (
            <>
              <CircularProgress size={16} color="inherit" style={{ marginRight: '8px' }} />
              Saving...
            </>
          ) : (
            <>
              Save & Next
              <ChevronRightIcon />
            </>
          )}
        </Grid>
      </div>
    </div>
  );
};

export default POStatusTab;
